module.exports = __webpack_public_path__ + "static/img/sec1-main-img@t.cda41fd.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/transys/sec1-main-img@t.jpg
// module id = fhpC
// module chunks = 0